import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import { ModalTimeline } from 'components/ModalTimeline';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  cleanClaimsAction,
  cleanTimelineAction,
} from 'store/modules/claims/actions';

import { ClaimWrapper } from './ClaimWrapper';
import { ModalDraft } from './ModalDraft';
import { NotifyClaim } from './NotifyClaim';
import { Main } from './styles';

export const Home = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(cleanClaimsAction());
      dispatch(cleanTimelineAction());
    };
  }, [dispatch]);

  return (
    <>
      <Header />
      <Menu />
      <Main>
        <NotifyClaim />
        <ClaimWrapper type="active" title="Sinistros Ativos" />
        <ClaimWrapper type="completed" title="Sinistros Concluídos" />
      </Main>
      <ModalDraft />
      <ModalTimeline />
    </>
  );
};
